import axios from 'axios';
import { AdminAuthCredentials, AdminAuthResponse } from '../types/adminRoute';

const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

export const validateAdminApiKey = async (credentials: AdminAuthCredentials): Promise<AdminAuthResponse> => {
  try {
    // For now, we'll simulate admin API key validation
    // In a real implementation, this would make an API call to validate the admin key
    const response = await axios.post(`${API_BASE_URL}/api/admin/validate`, {
      apiKey: credentials.adminApiKey
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });

    return {
      success: true,
      message: 'Admin API key validated successfully'
    };
  } catch (error: any) {
    if (error.response?.status === 401) {
      return {
        success: false,
        message: 'Invalid admin API key'
      };
    }
    if (error.response?.status === 403) {
      return {
        success: false,
        message: 'Admin access denied'
      };
    }
    return {
      success: false,
      message: 'Failed to validate admin API key'
    };
  }
}; 